import logo from "./icons/ic_logo.svg";
import logo2 from "./icons/ic_logo.svg";
import account from "./icons/ic_account.png";
import dashboard from "./icons/ic_dashboard.png";
import debit_card from "./icons/ic_debit_card.png";
import tran_history from "./icons/ic_tran_history.png";
import transfer from "./icons/ic_transfer.png";
import wallet from "./icons/ic_wallet.png";
import logout from "./icons/ic_logout.png";
import upload from "./icons/upload.svg";
import uploadBlack from "./icons/uploadBlack.svg";

import envelope from "./icons/envelope.svg";
import open_eye from "./icons/eye.svg";
import facebook from "./icons/Facebook.png";
import google from "./icons/Google.png";
import back_arrow from './icons/arrow-left.svg';
import mark from "./icons/mark.svg";
import refresh from './icons/refresh.svg';
import logoW from './icons/logoW.svg';
import logoIcon from './icons/logoIcon.svg';
import dropdown from './icons/ic_dropdown.svg';
import ic_transaction from './icons/ic_transaction.svg';
import ic_human from './icons/ic_human.svg';
import cross from './icons/cross.svg';
import naira_wallet from './icons/naira_wallet.svg';
import transfers from './icons/double_right.svg';
import exchange from './icons/exchange.svg';
import credit_card from './icons/credit-card.svg'
import nigeria_small from './icons/nigeria_small.svg';
import usa_small from './icons/usa_small.svg';
import empty_transaction from './icons/empty_transaction.png';
import saved_beneficiary from './icons/saved_beneficiary.svg';
import user_add from './icons/user_add.svg';
import transfer_history from './icons/transfer_history.svg';
import money from './icons/money.png';
import acc1 from './icons/acc1.svg';
import acc2 from './icons/acc2.svg';
import acc3 from './icons/acc3.svg';
import acc4 from './icons/acc4.svg';
import acc5 from './icons/acc5.svg';
import acc6 from './icons/acc6.svg';
import acc7 from './icons/acc7.svg';
import acc8 from './icons/acc8.svg';
import add from './icons/add.svg';
import bin from './icons/delete.svg';
import arrowRight from './icons/arrow_right.svg';
import swapCurrency from './icons/exchange_color.svg';
import addColor from './icons/add_color.svg';
import download from './icons/download_color.svg';
import refreshWhite from './icons/refresh_white.svg';
import bankCardIcon from './icons/bankCardIcon.svg';
import copyClipboard from './icons/copy_clipboard.svg';
import downArrow from './icons/down_arrow.svg';
import question from './icons/question.svg';
import euro_small from './icons/euro_small.svg';
import location from './icons/location.svg';
import threedots from './icons/threedots.svg';
import deactivate from './icons/deactivate.svg';
import cancelButton from './icons/cancel_button.svg';
import eye_close from './icons/eye_close.svg'
import error from './icons/error.svg';
import vertical_dropdown from "./icons/vertical_dropdown.svg";
import trash_danger from "./icons/trash_danger.svg";
import edit_outline from "./icons/edit_outline.svg";

export default {
  error,
  deactivate,
  threedots,
  vertical_dropdown,
  location,
  bankCardIcon,
  downArrow,
  copyClipboard,
  question,
  bin,
  add,
  uploadBlack,
  trash_danger,
  edit_outline,
  upload,
  acc1,
  acc2,
  acc3,
  acc4,
  acc5,
  acc6,
  acc7,
  acc8,
  logo,
  account,
  dashboard,
  debit_card,
  tran_history,
  transfer,
  wallet,
  logout,
  envelope,
  open_eye,
  facebook,
  google,
  back_arrow,
  mark,
  refresh,
  logoW,
  logoIcon,
  logo2,
  dropdown,
  ic_transaction,
  ic_human,
  cross,
  naira_wallet,
  exchange,
  credit_card,
  transfers, 
  nigeria_small,
  usa_small,
  euro_small,
  empty_transaction,
  transfer_history,
  user_add,
  saved_beneficiary,
  money,
  empty_transaction,
  arrowRight,
  swapCurrency,
  addColor,
  download,
  refreshWhite,
  cancelButton,
  eye_close
};
